import { Vue, Component, Watch } from 'vue-property-decorator'
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue'
import { Breadcrumb } from '@/interfaces/breadcrumbs'
import { showErrors, showNotification } from '@/utils/snack'
import { SnackType } from '@/interfaces/snack'
import AppTextField from '@/components/AppTextField.vue'
import AppFormItem from '@/components/AppFormItem.vue'
import AppListSelector from '@/components/AppListSelector.vue'
import AppSimpleDistrictSelector from '@/components/AppSimpleDistrictSelector.vue'
import { SchoolModel } from '@/interfaces/school'
import { updateSchool, createSchool } from './gql'
import { findSchool } from '../SchoolList/gql'
import { TypedGqlError } from '@/interfaces/error'
import AppDialog from '@/components/AppDialog.vue'

Component.registerHooks([
  'beforeRouteLeave'
])

@Component({
  components: {
    AppBreadcrumbs,
    AppTextField,
    AppFormItem,
    AppListSelector,
    AppSimpleDistrictSelector,
    AppDialog
  }
})
export default class Editgoods extends Vue {
  breadcrumbs: Breadcrumb[] = [
    {
      text: '学校管理'
    },
    {
      text: '学校',
      to: { name: 'SchoolList' }
    }
  ]

  items = ['基本信息', '经销商'];
  school: SchoolModel | null = null
  schoolInput: any = { area: null, name: '', status: null }
  originInput = ''

  // 判断新建还是编辑
  isEdit = false
  activeTab = 0
  schoolId = ''
  editSchoolName = ''
  hint = {
    text: '',
    color: ''
  }

  disabledActions = true

  isLeave = false

  @Watch('schoolInput.area', { deep: true, immediate: true })
  onAreaChange (val: any) {
    if (!val) {
      this.hint.text = '请选择地区'
      this.hint.color = 'red'
    } else {
      this.hint = {
        text: '',
        color: ''
      }
    }
  }

  @Watch('schoolInput', { deep: true })
  schoolInputChange (val: any) {
    if (JSON.stringify(val) !== this.originInput) {
      this.disabledActions = false
    } else {
      this.disabledActions = true
    }
  }

  // mounted
  async mounted () {
    // 判断是否为编辑
    const type = sessionStorage.getItem('type')
    if (type) {
      await this.initData(type)
    } else {
      sessionStorage.setItem('type', this.$route.params.type)
      await this.initData(this.$route.params.type)
    }
  }

  // 初始化数据
  async initData (type: string) {
    if (type === 'new') {
      // 新建
      this.isEdit = false
      this.breadcrumbs.push({ text: '添加学校' })
    } else {
      // 编辑
      this.isEdit = true
      const { id } = this.$route.params
      this.schoolId = id
      await this.getSchoolById()
    }
  }

  // 查询by id
  async getSchoolById () {
    try {
      const result = await this.$apollo.query({
        query: findSchool,
        variables: {
          schoolId: +this.schoolId
        }
      })
      if (result) {
        const { area, name } = result.data.findSchool
        this.schoolInput = {
          name, area
        }
        this.originInput = JSON.stringify(this.schoolInput)
        this.breadcrumbs = [
          {
            text: '学校管理'
          },
          {
            text: '学校',
            to: { name: 'SchoolList' }
          }
        ]
        this.breadcrumbs.push({ text: `${name}` })
      }
    } catch (error) {
      const typedError = error as TypedGqlError
      showErrors(typedError.graphQLErrors)
    }
  }

  // 清空form
  clearForm () {
    this.schoolInput = {
      area: null,
      name: '',
      dealerArea: null
    }
  }

  async submitBasic () {
    if (this.schoolInput.area) {
      await this.editSchoolRequest()
    } else {
      showNotification({
        msg: '请选择地区！',
        type: SnackType.Error
      })
    }
  }

  // 编辑学校request
  async editSchoolRequest () {
    if (this.validateForm('form')) {
      const { area, name } = this.schoolInput
      const request = !this.isEdit ? createSchool : updateSchool
      const msg = !this.isEdit ? '添加' : '编辑'
      const input = {
        areaId: area.id, name, status: 'PENDING'
      }
      let variables: any = {}
      if (this.isEdit) {
        const schoolId = +this.schoolId
        variables = { input, schoolId }
      } else {
        variables = { input }
      }
      try {
        const result = await this.$apollo.mutate({
          mutation: request,
          variables: {
            ...variables
          }
        })
        if (result) {
          showNotification({
            msg: `${msg}成功！`,
            type: SnackType.Success
          })

          this.isEdit = true
          sessionStorage.setItem('type', 'edit')
          this.disabledActions = true
          this.$router.go(-1)
        } else {
          showNotification({
            msg: `${msg}失败！`,
            type: SnackType.Error
          })
        }
      } catch (e) {
        const typedError = e as TypedGqlError
        showErrors(typedError.graphQLErrors)
      }
    }
  }

  // 表单重置验证
  resetValidation (form: string) {
    (
      this.$refs[form] as Vue & { resetValidation: () => void }
    ).resetValidation()
  }

  // 表单验证
  validateForm (form: string) {
    return (this.$refs[form] as Vue & { validate: () => boolean }).validate()
  }

  saveDialog = {
    title: '是否保存',
    show: false,
    text: ''
  }

  beforeDestroy () {
    if (!this.disabledActions) {
      this.saveDialog.show = true
    }
    sessionStorage.removeItem('type')
  }

  async beforeRouteLeave (to: any, from: any, next: any) {
    if (!this.disabledActions) {
      const res = confirm('页面修改尚未保存，是否确定要离开？')
      next(res)
    } else {
      next()
    }
  }
}
